import { OrganizationNodepProps } from '@axios/models';
import { User } from 'oidc-client';
import { ActionModel } from '../models';

export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const UPDATE_LOG_STATUS = 'UPDATE_LOG_STATUS';
export const UPDATE_TIMESTAMP_OF_CALLING_API = 'UPDATE_TIMESTAMP_OF_CALLING_API';
export const FETCHED_ORGS_TREE = 'FETCHED_ORGS_TREE';
export const FETCHING_ORGS_TREE = 'FETCHING_ORGS_TREE';
export const FETCHED_ACCOUNT = 'FETCHED_ACCOUNT';
export const FETCHED_LODING = 'FETCHED_LODING';
export const FETCHED_LOGIN_TYPE= 'FETCHING_LOGIN_TYPE';
export const FETCHING_ACCOUNT = 'FETCHING_ACCOUNT';
export const FETCHED_ACCOUNT_LOADING = 'FETCHED_ACCOUNT_LOADING';
export const FETCHED_ACCESS_SUCCESS = 'FETCHED_ACCESS_SUCCESS';
export const UPDATE_REGIS_SHOW = 'UPDATE_REGIS_SHOW';
export const SWITCH_MENU = 'SWITCH_MENU';
export const CHANGE_PWD_SHOW = 'CHANGE_PWD_SHOW';

export const UserLoginAction = (userInfo: User): ActionModel => {
  return {
    type: USER_LOGIN,
    payload: userInfo
  }
}

export const UpdateLogStatus = (status: boolean): ActionModel => {
  return {
    type: UPDATE_LOG_STATUS,
    payload: status
  }
}

export const UpdateTimeStampOfCallingAPIAction = (timestamp: number): ActionModel => {
  return {
    type: UPDATE_TIMESTAMP_OF_CALLING_API,
    payload: timestamp
  }
}

export const FetchedOrgsTree = (tree: OrganizationNodepProps[]): ActionModel => {
  return {
    type: FETCHED_ORGS_TREE,
    payload: tree
  }
}

export const FetchingOrgsTree = (): ActionModel => {
  return {
    type: FETCHING_ORGS_TREE,
    payload: null
  }
}

export const FetchedAccount = (res: any): ActionModel => {
  return {
    type: FETCHED_ACCOUNT,
    payload: res
  }
}

export const FetchingAccount = (): ActionModel => {
  return {
    type: FETCHING_ACCOUNT,
    payload: null
  }
}

export const FetchedAccountLoading = (loading: boolean): ActionModel => {
  return {
    type: FETCHED_ACCOUNT_LOADING,
    payload: loading
  }
}
export const FetchedAccountTokenSuccess=(): ActionModel => {
  return {
    type: FETCHED_ACCESS_SUCCESS,
    payload: null
  }
}
export const UpdateRegisShow=(show:boolean): ActionModel => {
  return {
    type: UPDATE_REGIS_SHOW,
    payload: show
  }
}
export const FetchedLoginType=(loginType:number): ActionModel => {
  return {
    type: FETCHED_LOGIN_TYPE,
    payload: loginType
  }
}

export const FetchedLoding=(loding:boolean): ActionModel => {
  return {
    type: FETCHED_LODING,
    payload: loding
  }
}

export const SwitchMenu=(key:string): ActionModel => {
  localStorage.setItem("menuKey",key)
  return {
    type: SWITCH_MENU,
    payload: key
  }
}

export const ChangePwdShow=(show:boolean): ActionModel => {
  return {
    type: CHANGE_PWD_SHOW,
    payload: show
  }
}